<template>
  <div>
    <div ref="top" v-if="sortedResults">
      {{sortedResults.length}} results found.
    </div>
    <!-- <b-field id="perPageSelect">
      <b-select size="is-small" v-model="perPage">
        <option value=20>20 per page</option>
        <option value=50>50 per page</option>
        <option value=100>100 per page</option>
      </b-select>
    </b-field>
    -->
    <b-switch class="compactSwitch" v-model="isCompact">
        Compact View
    </b-switch>
    <b-button  class="sortButton" v-if="isCompact"
      :icon-right="this.sortType === 'alpha' ?
        (this.sortReverse ? 'chevron-up' : 'chevron-down') : ''"
      v-on:click="toggleAlpha" >
      Alphabetical
    </b-button>
    <b-button class="sortButton" v-if="isCompact"
      :icon-right="sortType === 'length' ?
        (sortReverse ? 'chevron-up' : 'chevron-down') : ''"
      v-on:click="toggleLength" >
      Length
    </b-button>
    <div v-if="isCompact && sortedResults">
      <b-pagination
        v-if="sortedResults && sortedResults.length > 1000"
        :total="sortedResults.length"
        :per-page="1000"
        :simple="true"
        order="is-right"
        @change="scrollUp"
        :current.sync="currCompact">
      </b-pagination>
      <div class="compactResults">
        <span
          v-for="result in sortedResults.slice((this.currCompact-1)*1000, this.currCompact*1000)"
          class="compactResult"
          :key="result[columns[0].field]">
          {{ result[columns[0].field] }}
        </span>
      </div>
      <b-pagination
        v-if="sortedResults && sortedResults.length > 1000"
        :total="sortedResults.length"
        :per-page="1000"
        :simple="true"
        order="is-right"
        @change="scrollUp"
        :current.sync="currCompact">
      </b-pagination>
    </div>

    <div v-if="!isCompact && sortedResults">
      <b-table
        detailed
        custom-detail-row
        :has-detailed-visible="(row) => row.extra && row.extra.length"
        :data="sortedResults"
        :mobile-cards="false"
        :paginated="true"
        pagination-position="both"
        :pagination-simple="true"
        @page-change="scrollUp"
        :per-page="50"
        :current-page.sync="currTable">

        <b-table-column
          v-for="column in columns"
          :field="column.field"
          :label="column.label"
          :key="column.field">
          <template v-slot:header="{ column }">
              <span class="tableHead">{{column.label}}</span>
              <b-button class="sortButton" size="is-small" type="is-ghost"
                :icon-right="sortType === 'alpha' ?
                  (sortReverse ? 'chevron-up' : 'chevron-down') : ''"
                v-on:click="toggleAlpha" >
                Alphabetical
              </b-button>
              <b-button class="sortButton" size="is-small" type="is-ghost"
                :icon-right="sortType === 'length' ?
                  (sortReverse ? 'chevron-up' : 'chevron-down') : ''"
                v-on:click="toggleLength" >
                Length
              </b-button>
          </template>
          <template v-slot="props">
            {{ props.row[column.field] }}
          </template>
        </b-table-column>

        <template slot="detail" slot-scope="props">
          <tr v-for="item in props.row.extra" :key="item.name" class="extraRow">
            <td></td>
            <td v-for="column in columns" :key="column.field">
              {{ item[column.field] }}
            </td>
          </tr>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    results: Array,
    columns: Array,
  },
  data() {
    return {
      currTable: 1,
      currCompact: 1,
      isCompact: false,
      sortField: '',
      sortType: 'alpha',
      sortReverse: false,
    };
  },
  methods: {
    scrollUp() {
      this.$refs.top.scrollIntoView();
    },
    toggleAlpha() {
      if (this.sortType === 'alpha') {
        this.sortReverse = !this.sortReverse;
        return;
      }
      this.sortReverse = false;
      this.sortType = 'alpha';
    },
    toggleLength() {
      if (this.sortType === 'length') {
        this.sortReverse = !this.sortReverse;
        return;
      }
      this.sortReverse = false;
      this.sortType = 'length';
    },

  },
  watch: {
    results() {
      this.currTable = 1;
      this.currCompact = 1;
    },
  },
  computed: {
    sortBy() {
      return this.columns[0].label;
    },
    sortedResults() {
      if (!this.results) return null;
      const toSort = [...this.results];
      return toSort.sort((a, b) => {
        let aa = a;
        let bb = b;
        if (this.sortReverse) {
          bb = a;
          aa = b;
        }
        if (this.sortType === 'alpha') {
          return (`${aa[this.sortBy]}`).localeCompare(`${bb[this.sortBy]}`);
        }
        return bb[this.sortBy].length - aa[this.sortBy].length;
      });
    },
  },
};
</script>

<style>
.table-wrapper {
  border: 1px solid #dbdbdb;
  border-radius: 8px;
}
.top.level {
  margin-bottom: 1rem;
}
div.compactResults {
  margin-top: 20px;
  margin-bottom: 20px;
  overflow-y: auto;
}
span.tableHead {
  margin-right: 6px;
  line-height: 30px;
}
.compactSwitch {
  line-height: 40px;
}
.sortButton {
  margin: 2px;
}
span.compactResult {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0px 3px;
  margin: 3px 3px;
  float: left;
}
tr.extraRow {
  background-color: #f4f4f4;
}
</style>
